import type { WidgetType } from '@/types/dashboardConfig'

/** Word 风格常用字号，范围 8～72px */
export const DASHBOARD_FONT_SIZE_PRESETS = [
  8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72,
] as const

export function isDashboardPresetFontSize(n: number): boolean {
  return (DASHBOARD_FONT_SIZE_PRESETS as readonly number[]).includes(n)
}

/** 可设置「正文/主显示区」字号的控件 */
export function widgetHasContentFontControl(type: WidgetType): boolean {
  return ['ValueCard', 'Gauge', 'StatusBadge', 'ControlButton', 'FocusButton', 'AlarmList'].includes(type)
}

/** 可设置标题/标签区字号的控件（WidgetShell 标题或开关旁说明） */
export function widgetHasLabelFontControl(type: WidgetType): boolean {
  return ['ValueCard', 'Gauge', 'TrendLine', 'AlarmList', 'ToggleSwitch'].includes(type)
}

/** 画布上可测量「自动」正文字号 */
export function widgetSupportsContentFontMeasure(type: WidgetType): boolean {
  return type !== 'TrendLine' && widgetHasContentFontControl(type)
}

/** 画布上可测量「自动」标签字号 */
export function widgetSupportsLabelFontMeasure(type: WidgetType): boolean {
  return widgetHasLabelFontControl(type)
}
